import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * The old standalone Documents pages (/documents, /documents/new, /documents/:id and
 * /documents/:id/edit) are gone: documents live in each employee's profile. An old link or
 * bookmark lands where its documents are now. HR (documents:read_all) goes to the employee
 * the link names (?employee_id=) or else to the Employees list; everyone else goes to the
 * Documents section of their own profile.
 */
const DocumentsRedirect = () => {
  const { hasPermission } = useAuth();
  const [params] = useSearchParams();
  const employeeId = params.get('employee_id');

  if (hasPermission('documents', 'read_all')) {
    const target = /^[1-9]\d*$/.test(employeeId || '') ? `/employees/${employeeId}#documents` : '/employees';
    return <Navigate to={target} replace />;
  }
  return <Navigate to="/profile#documents" replace />;
};

export default DocumentsRedirect;
